import styled from 'styled-components';

/** Any children of this wrapper that have the .appearOnHover className will be hidden until the hover for this wrapper is triggered */

export const APPEAR_ON_HOVER_CLASS = 'appearOnHover';

export const AppearOnHoverWrapper = styled.div`
	& .${APPEAR_ON_HOVER_CLASS} {
		opacity: 0.1;
		transition: all 0.2s ease-in-out;
	}
	&:hover {
		& .${APPEAR_ON_HOVER_CLASS} {
			opacity: 1;
		}
	}

	/* On devices that don't support hover, keep the button visible */
	@media (hover: none) {
		.${APPEAR_ON_HOVER_CLASS} {
			opacity: 1;
		}
	}
`;
